import { BrowserModule } from "@angular/platform-browser";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { enableProdMode,NgModule } from "@angular/core";
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// no layouts views
import { LandingComponent } from "./views/landing/landing.component";
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import {GoTopButtonModule} from 'ng-go-top-button';
// components for views and layouts

import { FooterComponent } from "./components/footers/footer/footer.component";
import { IndexNavbarComponent } from "./components/navbars/index-navbar/index-navbar.component";

import { NgImageSliderModule } from 'ng-image-slider';

enableProdMode();

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    IndexNavbarComponent,
    LandingComponent,
  ],
  imports: [
    BrowserModule, 
    AppRoutingModule,
    HttpClientModule,
    ScrollToModule.forRoot(),
    BrowserAnimationsModule,
    GoTopButtonModule,
    NgImageSliderModule
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
